import { render } from "./OrdersList.vue?vue&type=template&id=42e2967e&scoped=true"
import script from "./OrdersList.vue?vue&type=script&lang=js"
export * from "./OrdersList.vue?vue&type=script&lang=js"

import "./OrdersList.vue?vue&type=style&index=0&id=42e2967e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-42e2967e"]])

export default __exports__